import React, { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import * as api from "../../../actions/api";
import LabTestListFormData from "./LabTestListFormData"
import encryptionService from "../../../services/encryptionService";

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const EditLabTestList = (props) => {

    //get DispensingLanguage
  const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
  const lan = localStorage.getItem('LangCode');
  const menukey = "lab-test-list";
  const UserInfo = encryptionService.decryptUserInfo();  
  const UserName = UserInfo==0?'': UserInfo[0].name;

  const [formData, setFormData] = useState({
    TestName:"",  
    FTypeIds: "",
    TestSettings: "",
    UnitName: "",
    IsCD4: false,
    IsVirale: false,
    PaquetMinimum: false,
	
  });
  
  const [errorObject, setErrorObject] = useState({});
  const { id } = useParams();
  const queryClient = useQueryClient();

   const { data } = useQuery(
    ["labtest", id],
    () =>
      api.geLabTestLists(id).then((res) => {
        setFormData(res.data);
        return res.data;
      }),
    {
      enabled: Boolean(id),
    }
  ); 

  const { isLoading, mutate } = useMutation(api.updateLabTestList, {
    onSuccess: (data) => {
      if (data.status == 200) {
        // api.getAllDropdown('LABTest_List').then((response) => {
        //   localStorage.setItem(
        //     "LABTest_List",
        //     JSON.stringify(response.datalist.LABTest_List)
        //   );
        // })
        
        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: data.data.success,
        });

        queryClient.getQueriesData("labtest");// include the page name
        props.history.push("/lab-test-list");//page url
       
        }else{   
          props.openNoticeModal({
            isOpen: true,
            msg: data.data.message,
            msgtype: data.data.success,
          });
        }
    },
  });



  const handleChange = (e) => {
    const { name, value } = e.target;
    let data = { ...formData };
    data[name] = value;

    setFormData(data);
    setErrorObject({ ...errorObject, [name]: null });
  };

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
  };

  const handleReset = () => {
    setFormData({
      TestName:"",  
      FTypeIds: "",
      TestSettings: "",
      UnitName: "",
      IsCD4: false,
      IsVirale: false,
      PaquetMinimum: false,
    });
  };

  const validateForm = (formData) => {
    let validateFields = ["TestName","TestSettings"];
    let errorData = {};
    let isValid = true;
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] = (DispensingLanguage[lan][menukey]['field is Required !']);
        isValid = false;
      }
    });
    setErrorObject(errorData);
    return isValid;
  };

  const handleUpdate = async (e) => {
    console.log("from Update ", formData);
    if (validateForm(formData)) {
      let fDtat={...formData,"menukey": menukey,"lan":lan,"UserName":UserName}; 
      mutate(fDtat);
      //mutate(formData);
     
    }
  };

  //====== Start Choosen Dropdown===========
  const handleChangeChoosenProps = (name, value) => {
    let data = { ...formData };
    data[name] = value;   
    setFormData(data); 
    setErrorObject({ ...errorObject, [name]: "" });
      
  }
  //====== End Choosen Dropdown===========

  return (
    <>
      <LabTestListFormData
        errorObject={errorObject}
        addProductForm={false}
        formData={formData}
        handleChange={handleChange}
        handleCheck={handleCheck}
        handleReset={handleReset}
        handleUpdate={handleUpdate}
        handleChangeChoosenProps={handleChangeChoosenProps}
        setFormData={setFormData}
        {...props}
      />
    </>
  );
};

export default EditLabTestList;
